// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__37Ly7","description":"MealItem_description__3xIr6","price":"MealItem_price__EI9WL"};